import { render, staticRenderFns } from "./RoomCard.vue?vue&type=template&id=c1c25ec2&scoped=true&"
import script from "./RoomCard.vue?vue&type=script&lang=js&"
export * from "./RoomCard.vue?vue&type=script&lang=js&"
import style0 from "./RoomCard.vue?vue&type=style&index=0&id=c1c25ec2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c25ec2",
  null
  
)

export default component.exports